/* Ivii NFC card customizer: live preview + variant-aware pricing.
   Assumes product options are named "Color" and optionally "Logo". */

document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var jsonEl = document.querySelector('[data-product-json]');
  var variants = [];
  try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }

  var preview = document.querySelector('[data-customizer-preview]');
  var variantIdInput = form.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-price]');
  var unitEl = form.querySelector('[data-summary-unit]');
  var totalEl = form.querySelector('[data-summary-total]');
  var logoPriceEl = form.querySelector('[data-logo-price]');
  var logoToggle = form.querySelector('[data-logo-toggle]');
  var qtyInput = form.querySelector('[data-quantity-input]');

  // Card color option values are merchant-editable text (e.g. "Black & Gold",
  // "Gold on Black"...) so we key styling off whether "Silver"/"White" appear
  // anywhere in the value, rather than matching the exact string.
  function metalName(color) {
    return (color || '').indexOf('Silver') !== -1 ? 'silver' : 'gold';
  }

  function baseName(color) {
    return (color || '').indexOf('White') !== -1 ? 'white' : 'black';
  }

  function selectedOptions() {
    var colorInput = form.querySelector('input[name="Color"]:checked');
    var color = colorInput ? colorInput.value : null;
    var logo = logoToggle ? (logoToggle.checked ? 'Add Logo' : 'No Logo') : null;
    return { color: color, logo: logo };
  }

  function findVariant(opts) {
    return variants.find(function (v) {
      var matchesColor = !opts.color || v.option1 === opts.color || v.options.indexOf(opts.color) !== -1;
      var matchesLogo = !opts.logo || v.options.indexOf(opts.logo) !== -1;
      return matchesColor && matchesLogo;
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function logoSurcharge(color) {
    if (!logoToggle) return 0;
    var withLogo = findVariant({ color: color, logo: 'Add Logo' });
    var withoutLogo = findVariant({ color: color, logo: 'No Logo' });
    if (withLogo && withoutLogo) return withLogo.price - withoutLogo.price;
    return 0;
  }

  function updatePricing() {
    var opts = selectedOptions();
    var variant = findVariant(opts) || variants[0];
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var unitPrice = variant.price;

    if (priceEl) priceEl.textContent = formatMoney(unitPrice);
    if (unitEl) unitEl.textContent = formatMoney(unitPrice);
    if (totalEl) totalEl.textContent = formatMoney(unitPrice * qty);

    if (logoPriceEl) {
      var surcharge = logoSurcharge(opts.color);
      logoPriceEl.textContent = surcharge > 0 ? '+ ' + formatMoney(surcharge) : 'Included';
    }

    var submitBtn = form.querySelector('[data-submit]');
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
    }
  }

  // Second guard behind the disabled button: never post an unavailable variant.
  form.addEventListener('submit', function (e) {
    var variant = findVariant(selectedOptions());
    if (variant && !variant.available) e.preventDefault();
  });

  // Shopify's /discount/<code> route stores the code in a cookie for the session.
  function activeDiscountCode() {
    var match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!match) return '';
    try { return decodeURIComponent(match[1]).toUpperCase(); } catch (e) { return ''; }
  }

  var playbookNote = form.querySelector('[data-playbook-note]');
  if (playbookNote && activeDiscountCode() === 'PLAYBOOK20') playbookNote.hidden = false;

  var backImage = document.querySelector('[data-back-image]');

  function updateBackImage(color) {
    if (!backImage) return;
    var src = metalName(color) === 'silver' ? backImage.dataset.silverSrc : backImage.dataset.goldSrc;
    if (src && backImage.getAttribute('src') !== src) backImage.src = src;
  }

  function updatePreviewColor() {
    if (!preview) return;
    var opts = selectedOptions();
    if (opts.color) {
      preview.dataset.metal = metalName(opts.color);
      preview.dataset.base = baseName(opts.color);
    }
    updateBackImage(opts.color);
  }

  form.querySelectorAll('input[name="Color"]').forEach(function (input) {
    input.addEventListener('change', function () {
      updatePreviewColor();
      updatePricing();
    });
  });

  if (logoToggle) logoToggle.addEventListener('change', updatePricing);
  if (qtyInput) qtyInput.addEventListener('change', updatePricing);

  var firstName = form.querySelector('[data-preview-input="name-first"]');
  var lastName = form.querySelector('[data-preview-input="name-last"]');
  var company = form.querySelector('[data-preview-input="company"]');
  var previewName = document.querySelector('[data-preview-name]');
  var previewCompany = document.querySelector('[data-preview-company]');

  function updatePreviewText() {
    if (previewName) {
      var full = [(firstName && firstName.value), (lastName && lastName.value)].filter(Boolean).join(' ');
      previewName.textContent = full || 'Your Name Here';
    }
    if (previewCompany) {
      previewCompany.textContent = (company && company.value) || 'Your Business Inc.';
    }
  }

  [firstName, lastName, company].forEach(function (input) {
    if (input) input.addEventListener('input', updatePreviewText);
  });

  updatePreviewColor();
  updatePreviewText();
  updatePricing();

  /* ---------------- Logo upload: toggle, validate, monochrome preview ---------------- */

  var logoUploadBlock = form.querySelector('[data-logo-upload]');
  var logoFileInput = form.querySelector('[data-logo-file]');
  var logoWarning = form.querySelector('[data-logo-warning]');
  var fileInputText = form.querySelector('[data-file-input-text]');
  var previewLogo = document.querySelector('[data-preview-logo]');
  var logoSlot = document.querySelector('[data-logo-slot]');
  var logoClear = form.querySelector('[data-logo-clear]');
  var MIN_LOGO_DIMENSION = 400;
  var logoImage = null;

  function showLogoWarning(message) {
    if (!logoWarning) return;
    logoWarning.textContent = message;
    logoWarning.hidden = false;
  }

  function clearLogoWarning() {
    if (!logoWarning) return;
    logoWarning.textContent = '';
    logoWarning.hidden = true;
  }

  function hexToRgb(hex) {
    var clean = hex.replace('#', '');
    return {
      r: parseInt(clean.substring(0, 2), 16),
      g: parseInt(clean.substring(2, 4), 16),
      b: parseInt(clean.substring(4, 6), 16)
    };
  }

  function metalForColor(color) {
    return (color || '').indexOf('Silver') !== -1 ? '#c9ccd1' : '#c9a24b';
  }

  // Recolors the uploaded artwork to a single metallic tone, deriving opacity from
  // each pixel's darkness (and any existing alpha) so light/white backgrounds drop
  // out — approximating the look of a single-color foil-stamped logo.
  function tintLogo(img, hex) {
    var size = 160;
    var canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');
    var scale = Math.min(size / img.width, size / img.height);
    var w = img.width * scale;
    var h = img.height * scale;
    var x = (size - w) / 2;
    var y = (size - h) / 2;
    ctx.clearRect(0, 0, size, size);
    ctx.drawImage(img, x, y, w, h);

    var imageData = ctx.getImageData(0, 0, size, size);
    var data = imageData.data;
    var rgb = hexToRgb(hex);

    for (var i = 0; i < data.length; i += 4) {
      var luminance = (0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]) / 255;
      var originalAlpha = data[i + 3];
      data[i] = rgb.r;
      data[i + 1] = rgb.g;
      data[i + 2] = rgb.b;
      data[i + 3] = Math.round(originalAlpha * (1 - luminance));
    }

    ctx.putImageData(imageData, 0, 0);
    return canvas.toDataURL('image/png');
  }

  // Dashed placeholder shows where the logo will sit until a file is chosen.
  function syncLogoSlot() {
    var imageShown = previewLogo && !previewLogo.hidden;
    if (logoSlot) logoSlot.hidden = !(logoToggle && logoToggle.checked) || imageShown;
    if (logoClear) logoClear.hidden = !imageShown;
  }

  function renderLogoPreview() {
    if (!logoImage || !previewLogo) return;
    var opts = selectedOptions();
    previewLogo.src = tintLogo(logoImage, metalForColor(opts.color));
    previewLogo.hidden = false;
    syncLogoSlot();
  }

  function resetLogoPreview() {
    logoImage = null;
    if (previewLogo) { previewLogo.hidden = true; previewLogo.removeAttribute('src'); }
    syncLogoSlot();
  }

  function handleLogoFile(file) {
    clearLogoWarning();

    if (['image/jpeg', 'image/png'].indexOf(file.type) === -1) {
      showLogoWarning('Please upload a JPG or PNG file.');
      if (logoFileInput) logoFileInput.value = '';
      resetLogoPreview();
      return;
    }

    var reader = new FileReader();
    reader.onload = function (e) {
      var img = new Image();
      img.onload = function () {
        if (img.naturalWidth < MIN_LOGO_DIMENSION || img.naturalHeight < MIN_LOGO_DIMENSION) {
          showLogoWarning('This image is smaller than the recommended 400 x 400px minimum — we can still review it, but a higher-resolution file will print more crisply.');
        }
        logoImage = img;
        renderLogoPreview();
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  if (logoFileInput) {
    logoFileInput.addEventListener('change', function () {
      var file = logoFileInput.files && logoFileInput.files[0];
      if (fileInputText) fileInputText.textContent = file ? file.name : 'Choose a logo file…';
      if (!file) { resetLogoPreview(); return; }
      handleLogoFile(file);
    });
  }

  function clearLogoFile() {
    if (logoFileInput) logoFileInput.value = '';
    if (fileInputText) fileInputText.textContent = 'Choose a logo file…';
    clearLogoWarning();
    resetLogoPreview();
  }

  if (logoToggle) {
    logoToggle.addEventListener('change', function () {
      if (logoUploadBlock) logoUploadBlock.hidden = !logoToggle.checked;
      if (!logoToggle.checked) clearLogoFile();
      syncLogoSlot();
    });
  }

  if (logoClear) logoClear.addEventListener('click', function () {
    clearLogoFile();
    if (logoFileInput) logoFileInput.focus();
  });

  form.querySelectorAll('input[name="Color"]').forEach(function (input) {
    input.addEventListener('change', renderLogoPreview);
  });

  /* ---------------- Card flip: preview the (static) back of the card ---------------- */

  var flipContainer = document.querySelector('[data-card-flip]');
  var flipButton = document.querySelector('[data-flip-toggle]');
  var flipLabel = document.querySelector('[data-flip-label]');

  if (flipContainer && flipButton) {
    flipButton.addEventListener('click', function () {
      var flipped = flipContainer.classList.toggle('is-flipped');
      if (flipLabel) flipLabel.textContent = flipped ? 'View front of card' : 'View back of card';
    });
  }
});
